const merge = require('lodash/merge');
const { apiPortfolioId } = require('../../utils');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const base64 = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

function getUrl(endpoint) {
  return `${baseUrl}${endpoint}`;
}

return {
  getDailyStatementsData(portfolioId, startDate, endDate, outputType, metaData) {

    const url = getUrl('reports-overview');
    const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };

    const body = {
      pfId: parsedMetaData.portfolio.pfRelId,
      userId: parsedMetaData.qs.userId,
      branchCode: parsedMetaData.portfolio.branchCode,
      fromDate: startDate,
      toDate:endDate,
      statementType: outputType,
    };

    return requestHandler(merge(reqOpts, {
      url,
      body
    }));
  },
  getMonthlyStatementsData(portfolioId, startDate, endDate, outputType, metaData) {

    const url = getUrl('monthly-statements-overview');
    const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };

    const body = {
      pfId: parsedMetaData.portfolio.pfRelId,
      userId: parsedMetaData.qs.userId,
      branchCode: parsedMetaData.portfolio.branchCode,
      fromDate: startDate,
      toDate:endDate,
      statementType: outputType,
    };

    return requestHandler(merge(reqOpts, {
      url,
      body
    }));
  },

  getTransactionHistoryData(portfolioId, startDate, endDate, metaData) {
    const url = getUrl('view-transaction');
    const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };
    const body = {
      pfId: parsedMetaData.portfolio.pfRelId,
      userId: parsedMetaData.qs.userId,
      branchCode: parsedMetaData.portfolio.branchCode,
      fromDate: startDate,
      toDate:endDate,
      language: parsedMetaData.portfolio.language
    };

    return requestHandler(merge(reqOpts, {
      url,
      body
    }));
  },

  getLastStatementsData(portfolioId, metaData) {
    const url = getUrl('last-monthly-daily-statement');
    const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };

    const body = {
      pfId: parsedMetaData.portfolio.pfRelId,
      userId: parsedMetaData.qs.userId,
      branchCode: parsedMetaData.portfolio.branchCode
    };

    return requestHandler(merge(reqOpts, {
      url,
      body
    }));
  },

  getMonthStatement(portfolioId, startDate, endDate, outputType,  metaData) {

    const url = getUrl('monthly-daily-statements');
    const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };

    const body = {
      pfId: parsedMetaData.portfolio.pfRelId,
      userId: parsedMetaData.qs.userId,
      branchCode: parsedMetaData.portfolio.branchCode,
      fromDate: startDate,
      toDate:endDate,
      statementType: outputType
    };

    return requestHandler(merge(reqOpts, {
      url,
      body
    }));
  },

  getPdfLists(portfolioId, startDate, endDate, outputType, metaData) {

    const url = getUrl('reports-details');
    const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };

    const body = {
      pfId: parsedMetaData.portfolio.pfRelId,
      userId: parsedMetaData.qs.userId,
      branchCode: parsedMetaData.portfolio.branchCode,
      fromDate: startDate,
      toDate:endDate,
      statementType: outputType
    };

    return requestHandler(merge(reqOpts, {
      url,
      body
    }));
  },

  getTransactionAdvices(portfolioId, tradeNo,metaData) {
      const url = getUrl('transaction-advices');

      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const body = {
        pfId: parsedMetaData.portfolio.pfRelId,
        tradeNo:tradeNo,
        branchCode:parsedMetaData.portfolio.branchCode,
        userId: parsedMetaData.qs.userId
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));

    },

  getPdfStatement(accountId,  docId, metaData) {
    const url = getUrl('view-pdf');
    const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };

    const body = {
      userId: parsedMetaData.qs.userId,
      acnum: accountId,
      docId: docId,
      branchCode: parsedMetaData.portfolio.branchCode
    };

    return requestHandler(merge(reqOpts, {
      url,
      body
    }));
  },

  getTransactionHistoryDataForEdeliveryApp(portfolioId, startDate, endDate, metaData) {
    const url = getUrl('customReports-transaction-view');
    const decodedpfIdParam = base64.decode(portfolioId);
    const pfIdStringArray = decodedpfIdParam.split('$');
    const pfIdNumberArray = pfIdStringArray.map(String);
    const pfIdString = pfIdNumberArray.join(',');
    const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };
    const body = {
      pfId: pfIdString,//parsedMetaData.portfolio.pfRelId,
      userId: parsedMetaData.qs.userId,
      branchCode: parsedMetaData.portfolio.branchCode,
      fromDate: startDate,
      toDate:endDate,
      language: parsedMetaData.portfolio.language,
    };

    return requestHandler(merge(reqOpts, {
      url,
      body
    }));
  },

  getTransactionHistoryDataForEdelivery(portfolioId, startDate, endDate, metaData, channel) {
    const url = getUrl('customReports-transaction-view');
    const decodedpfIdParam = base64.decode(portfolioId);
    const pfIdStringArray = decodedpfIdParam.split('$');
    const pfIdNumberArray = pfIdStringArray.map(String);
    const pfIdString = pfIdNumberArray.join(',');
    const parsedMetaData = parseRequestMetaData(metaData);
    const branchCode = parsedMetaData.portfolio.branchCode === 999999999? parsedMetaData.configBranchCode : parsedMetaData.portfolio.branchCode;
      const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };
    const body = {
      pfId: pfIdString,//parsedMetaData.portfolio.pfRelId,
      userId: parsedMetaData.qs.userId,
      branchCode: branchCode,
      fromDate: startDate,
      toDate:endDate,
      language: parsedMetaData.portfolio.language,
      channel: channel
    };

    return requestHandler(merge(reqOpts, {
      url,
      body
    }));
  },
};
}

module.exports = apiFactory;
